module.exports = __webpack_public_path__ + "static/media/google-play-badge.00527dd0.png";